import $ from 'jquery'
import { Controller } from 'stimulus'
import { sendSimpleroId } from '~/site/pages/cart/login'
export default class extends Controller {
  static targets = ['embeddedInIframe', 'agreement']
  static values = {
    stepName: String,
  }

  connect() {
    this.isOneStepCheckout = this.stepNameValue === 'one_step'
    this.embeddedInIframeTarget.value = document.querySelector('.inside-iframe')
      ? 1
      : 0

    document.addEventListener('focusin', this.rememberFocus)
    document.addEventListener('click', this.handleClick)
    $(document).on('simplero-cart-updated', this.restoreFocus)
  }

  disconnect() {
    document.removeEventListener('focusin', this.rememberFocus)
    document.removeEventListener('click', this.handleClick)
    $(document).off('simplero-cart-updated', this.restoreFocus)
  }

  sendSimpleroId(event) {
    sendSimpleroId(event)
  }

  rememberFocus = (event) => {
    this.lastFocusTargetId = event.target.id
  }

  forgetFocus() {
    this.lastFocusTargetId = null
  }

  handleClick = (event) => {
    const targetTag = event.target.tagName

    if (targetTag == 'INPUT' || targetTag == 'TEXTAREA') {
      this.rememberFocus(event)
    } else {
      this.forgetFocus()
    }
  }

  restoreFocus = () => {
    if (!this.lastFocusTargetId) return

    const focusTarget = document.getElementById(this.lastFocusTargetId)

    if (!focusTarget) return

    // Focus last focused input
    focusTarget.focus()

    // Emulate tabbing and select the input contents if selectable
    if (focusTarget.select) focusTarget.select()

    this.forgetFocus()
  }
}
